import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { GenericPageError } from '@components/core-ui/GenericPageError';
import { Input } from '@components/core-ui/form-elements/Input';
import { AbsoluteSpinner } from '@components/core-ui/spinners/Spinner';
import { useAPI } from '@providers/useAPI';
import { useAuthContext } from '@providers/AuthProvider';
import { useModalContext } from '@providers/ModalProvider';
import { AdminService, GetSettingsResponseSetting } from 'app/API';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { Content } from './styles/Content';

type TProps = {
  onCancel: () => void;
  onSuccess: () => void;
  setting: GetSettingsResponseSetting;
};

export const AdminEditSettingModal = ({ onCancel, onSuccess, setting }: TProps) => {
  const { me } = useAuthContext();
  const { call } = useAPI();
  const { closeModal } = useModalContext();
  const [value, setValue] = useState(setting.value);
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async () => {
    if (setting.name === 'TRANSCRIPTION_MODEL' && !['1', '2'].includes(value)) {
      toast.error('TRANSCRIPTION_MODEL should has value 1 or 2');
      return;
    }
    setIsLoading(true);
    await call(AdminService.updateSetting({ name: setting.name, requestBody: { value } }));
    setIsLoading(false);
    closeModal();
    onSuccess();
  };

  const isSubmitDisabled = isLoading || !value || !value.length;
  const isVsAdmin = me?.roles?.includes('ROLE_VS_ADMIN');
  const isVsBilling = me?.roles?.includes('ROLE_BILLING_ADMIN');

  if (!isVsAdmin || (!isVsBilling && setting?.name === 'SIGNUP_CREDIT_AMOUNT')) {
    return (
      <ModalWrapper width="400px">
        <GenericPageError message="You don't have enough permissions to edit this setting" />
        <Content>
          <div className="buttonGroup">
            <Button onClick={onCancel}>Ok</Button>
          </div>
        </Content>
      </ModalWrapper>
    );
  }

  return (
    <ModalWrapper width="400px">
      {isLoading ? <AbsoluteSpinner overlay={true} /> : null}
      <ModalTitle>Edit {setting.name} Setting</ModalTitle>
      <Content>
        <div className="input-wrapper">
          <div className="label">Value</div>

          <div className="flex flex-row">
            <Input
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setValue(e.target.value)}
              label="Value"
              value={value}
            />
          </div>
        </div>

        <div className="buttonGroup">
          <OutlinedButton onClick={onCancel}>Cancel</OutlinedButton>
          <Button disabled={isSubmitDisabled} onClick={onSubmit}>
            Save
          </Button>
        </div>
      </Content>
    </ModalWrapper>
  );
};
